import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Router } from '@reach/router';
import Layout from '../../components/layout';
import { Publications as PublicationsComponent } from '../../components/news/publications';
import '../../components/news/styles.scss';

const Publications = () => {
  const data = useStaticQuery(graphql`
    {
      allContentfulPub {
        nodes {
          articleContent {
            raw
          }
          title
        }
      }
    }
  `);

  const { allContentfulPub } = data;

  return (
    <Layout headerText={'NEWS'} heroFont="has-text-white" heroBg="fields">
      <Router>
        <PublicationsComponent
          path="/news/publications"
          allContentfulPub={allContentfulPub}
        />
      </Router>
    </Layout>
  );
};

export default Publications;
